import { memo, useState } from "react";
import Button from "../../_widgets/Button/Button";
import Text from "./../../_widgets/Text/Text";
import IconResource from "../../../Wrapper/IconResource/IconResource";
import { Form, Table, Card, Row, Col } from "react-bootstrap";
import "./../style.scss";
import { Link } from "react-router-dom";
import NavBar from "../../_widgets/NavBar/NavBar";
import AnimatedPage from "../../AnimatedPage/AnimatedPage";
import Input from "../../_widgets/Input/Input";
import Dropdown from "../../_widgets/Dropdown/Dropdown";
import { getLanguage, getTemplatesCategory, getTemplatesOptions } from "../../../Services/common";
import { warn } from "../../../Wrapper/toast/toast";
import {
  MAX_100_CHARS,
  MAX_10_CHARS,
  MAX_20_CHARS,
  MAX_50_CHARS,
  MAX_60_CHARS,
} from "../../../Constants/stringConstants";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import styles for the editor
import { capitalizeFirstLetter } from "../../../Utils/stringUtils";
import { IMAGE_URL } from "../../../Constants/urlConstants";
import TemplateDetails from "./TemplateDetails";
const TemplateDetailsUI = memo(
  ({
    templateData,
    setTemplateData,
    handleSave,
    message,
    footerText,
    setFooterText,
    toolbarOptions,
    parseHtml,
    buttonLoading,
    navigateBack,
    handleAddVariable,
    variableValues,
    variables,
    handleVariableChange,
    handleMessageChange,
    setCursorPosition,
    headerText,
    setHeaderText,
    headerFormat,
    setHeaderFormat,
    setHeaderMedia,
    headerMedia,
    uploadFiles,
  }) => {
    const maxLength = 1024;
    const maxFooterLength = 60;
    const [customVarName, setCustomVarName] = useState("");
    return (
      <AnimatedPage>
        <NavBar heading={`Template Details`} onClick={() => navigateBack()} Icon="backangle" />

        <Row>
          <Col md={8}>
            <div className="white_card add-template text-start">
              <Card>
                <Card.Body>
                  <span
                    className="d-flex w-100  my-2 flex-column justify-content-start
                             align-items-start"
                  >
                    <Text
                      type="h5"
                      text="What message do you want to send?"
                      className="mb-2 fw-bold"
                    />
                    <Text type="h6" text="Add broadcast name and template below." />
                  </span>

                  <Row>
                    <Col lg={4}>
                      <Form.Group className="mb-3">
                        <Input
                          disabled={true}
                          placeholder="Enter Name"
                          type="text"
                          label="Template name"
                          controlId="validationCustom01"
                          required
                          isRequired
                          value={templateData?.name?.toLowerCase()}
                          onChange={(e) => {
                            let value = e.target.value.replace(/\s+/g, "_"); // Replace spaces with _
                            if (value.length < 20) {
                              setTemplateData({ ...templateData, name: value });
                            } else {
                              warn(MAX_20_CHARS);
                            }
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={4}>
                      <Form.Group className="mb-3">
                        <Dropdown
                          isDisabled={true}
                          label="Category"
                          placeholder="Category"
                          isRequired
                          name={templateData.category}
                          options={getTemplatesCategory()}
                          onChange={(value) =>
                            setTemplateData({
                              ...templateData,
                              category: value,
                            })
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={4}>
                      <Form.Group className="mb-3">
                        <Dropdown
                          isDisabled={true}
                          label="Language"
                          placeholder="Language"
                          isRequired
                          name={templateData.language}
                          options={getLanguage()}
                          onChange={(value) =>
                            setTemplateData({
                              ...templateData,
                              language: value,
                            })
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={4}>
                      <Dropdown
                        isDisabled={true}
                        label="Header Type"
                        placeholder="Select header type"
                        name={headerFormat}
                        options={[
                          { label: "None", value: "NONE" },
                          { label: "Text", value: "TEXT" },
                          { label: "Image", value: "IMAGE" },
                          { label: "Video", value: "VIDEO" },
                          { label: "Document", value: "DOCUMENT" },
                          // { label: 'Location', value: 'LOCATION' },
                        ]}
                        onChange={(value) => {
                          setHeaderFormat(value);
                          setHeaderText(value === "TEXT" ? headerText : "");
                          setHeaderMedia(
                            ["IMAGE", "VIDEO", "DOCUMENT"].includes(value) ? headerMedia : null,
                          );
                        }}
                      />
                    </Col>

                    {headerFormat === "TEXT" && (
                      <Col lg={12} className="mb-3">
                        <Input
                          disabled={true}
                          type="text"
                          placeholder="Enter header text"
                          value={headerText}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (value.length < 60) {
                              setHeaderText(value);
                            } else {
                              warn(MAX_60_CHARS);
                            }
                          }}
                          isRequired
                        />
                        <small className="text-muted">{headerText.length}/60</small>
                      </Col>
                    )}

                    {["IMAGE", "VIDEO", "DOCUMENT"].includes(headerFormat) && (
                      <Col lg={12} className="mb-3">
                        <Form.Label>Upload {headerFormat.toLowerCase()}</Form.Label>
                        <Form.Control
                          disabled={true}
                          type="file"
                          accept={
                            headerFormat === "IMAGE"
                              ? "image/*"
                              : headerFormat === "VIDEO"
                                ? "video/*"
                                : ".pdf,.doc,.docx"
                          }
                          onChange={(e) => uploadFiles(e)}
                        />
                        <small className="text-muted">
                          {headerFormat === "IMAGE"
                            ? "Supported: JPEG, PNG"
                            : headerFormat === "VIDEO"
                              ? "Supported: MP4, MOV"
                              : "Supported: PDF, DOC, DOCX"}
                        </small>
                      </Col>
                    )}
                  </Row>

                  <Row>
                    <Col lg={12}>
                      <div className="mb-3">
                        {/* Title */}
                        <Form.Label className="fw-bold">
                          Body <span className="text-danger">*</span>
                        </Form.Label>

                        <Text
                          type="h6"
                          className="my-2"
                          text={" Make your message personal and get more replies."}
                        />
                        <div className="d-flex my-2 w-100 justify-content-end align-items-center">
                          <div className="d-flex align-items-center gap-2">
                            <Input
                              disabled={true}
                              type="text"
                              placeholder="Variable name"
                              value={customVarName}
                              onChange={(e) => setCustomVarName(e.target.value)}
                              className="form-control-sm"
                              style={{ width: "120px" }}
                            />
                            <Button
                              disabled={true}
                              className="btn emr-btn__outline addVariableButton"
                              buttonType="outline"
                              onClick={() => {
                                handleAddVariable(customVarName);
                                setCustomVarName("");
                              }}
                              text={"➕ Add Variable"}
                            />
                          </div>
                        </div>

                        <ReactQuill
                          readOnly={true}
                          value={message}
                          onChange={(content, delta, source, editor) => {
                            handleMessageChange(content);
                            // Track cursor position
                            const range = editor.getSelection();
                            if (range) {
                              setCursorPosition(range.index + 3);
                            }
                          }}
                          modules={{ toolbar: toolbarOptions }}
                          placeholder="Type your template message..."
                          className="rich-text-editor"
                        />
                        {/* Variable Input Fields Section */}
                        {variables.length > 0 && (
                          <div className="variable-input-section mt-3">
                            <h6>Variable Values</h6>
                            {variables.map((variable, index) => (
                              <div key={index} className="d-flex align-items-center gap-2 my-2">
                                <span className="fw-bold">{variable}</span>
                                <Input
                                  disabled={true}
                                  type="text"
                                  placeholder={`Enter value for ${variable}`}
                                  value={variableValues[variable] || ""}
                                  onChange={(e) => {
                                    let value = e.target.value;
                                    if (value?.length < 60) {
                                      handleVariableChange(variable, e.target.value);
                                    } else {
                                      warn(MAX_60_CHARS);
                                    }
                                  }}
                                  className="form-control"
                                />
                              </div>
                            ))}
                          </div>
                        )}
                        {/* Character Counter */}
                        <div className="text-muted text-end mt-1">
                          {message.replace(/<[^>]*>/g, "").length}/{maxLength}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={12}>
                      <div className="mb-3">
                        {/* Title */}
                        <Form.Label className="fw-bold">
                          Footer <span className="text-danger mx-1">*</span>
                        </Form.Label>

                        {/* Subtitle */}
                        <p className="text-muted small my-2">
                          Footers are great to add any disclaimers or to add a thoughtful PS.
                        </p>

                        {/* Input Field with Character Counter */}
                        <div className="position-relative">
                          <Form.Group className="mb-3">
                            <Input
                              disabled={true}
                              placeholder="Enter footer"
                              type="text"
                              className="border rounded bg-light"
                              controlId="validationCustom01"
                              value={footerText}
                              onChange={(e) => {
                                let value = e.target.value;
                                if (value?.length < 60) {
                                  setFooterText(e.target.value);
                                } else {
                                  warn(MAX_60_CHARS);
                                }
                              }}
                            />
                          </Form.Group>

                          {/* Character Counter */}
                          <small
                            className="position-absolute end-0 me-2 text-muted"
                            style={{ bottom: "10px" }}
                          >
                            {footerText.length}/{maxFooterLength}
                          </small>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
                <Card.Footer>
                  <Button
                    isLoading={buttonLoading}
                    buttonType="primary"
                    onClick={(e) => handleSave()}
                    text={"Copy & Create New"}
                  />
                </Card.Footer>
              </Card>
            </div>
          </Col>
          <Col md={4}>
            <Text className="text-left mb-2" type="h5" text="Preview" />

            <Card
              className="text-center"
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "18px", // Adjusted from 25px for a more realistic look
                boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.15)", // Softer shadow
                borderRadius: "18px", // Matched with Card
              }}
            >
              <Card.Body className="p-2">
                <div
                  className="whatsapp-preview border rounded mx-auto"
                  style={{
                    backgroundColor: "#efeae2",
                    height: "500px",
                    overflow: "hidden",
                    overflowY: "auto", // To prevent scrolling when content
                    borderRadius: "18px", // Matched with Card
                    backgroundImage:
                      "url('https://www.transparenttextures.com/patterns/asfalt-light.png')",
                    backgroundSize: "cover",
                    marginBottom: "50px",
                    border: "1px solid #d1d1d1", // Light border to define edges
                  }}
                >
                  {/* Header Bar */}
                  <div
                    className="whatsapp-header text-white p-2"
                    style={{
                      height: "45px",
                      backgroundColor: "#075e54",
                      borderTopLeftRadius: "18px",
                      borderTopRightRadius: "18px",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px",
                    }}
                  ></div>

                  {/* Info Message */}
                  <div
                    className="whatsapp-info p-2 rounded text-center mx-3"
                    style={{
                      fontSize: "12px",
                      color: "#555",
                      backgroundColor: "#e9f0f4",
                      borderRadius: "6px", // Reduced from 8px
                      fontWeight: "500",
                    }}
                  >
                    🔒 This business uses a secure service from Meta to manage this chat. Tap to
                    learn more
                  </div>

                  {/* Message Bubble */}
                  {templateData?.name && (
                    <div
                      className="whatsapp-message bg-white p-3 shadow-sm my-2 mx-auto"
                      style={{
                        maxWidth: "75%", // Adjusted for real proportions
                        textAlign: "left",
                        borderRadius: "12px", // Less rounded for realism
                        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
                        fontSize: "14px",
                        lineHeight: "1.4",
                        fontWeight: "400",
                        padding: "10px 12px", // More accurate padding
                      }}
                    >
                      {/* Dynamic Header */}

                      {headerFormat !== "NONE" && (
                        <div className="mb-3">
                          {headerFormat === "TEXT" && (
                            <h6 className="fw-bold">{capitalizeFirstLetter(headerText)}</h6>
                          )}
                          {headerFormat === "IMAGE" && headerMedia && (
                            <img
                              src={IMAGE_URL + headerMedia}
                              alt="header"
                              style={{ width: "100%", borderRadius: "8px" }}
                            />
                          )}
                          {headerFormat === "VIDEO" && headerMedia && (
                            <video
                              controls
                              src={IMAGE_URL + headerMedia}
                              style={{ width: "100%", borderRadius: "8px" }}
                            />
                          )}
                          {headerFormat === "DOCUMENT" && headerMedia && (
                            <a
                              href={
                                typeof headerMedia === "string"
                                  ? headerMedia
                                  : URL.createObjectURL(headerMedia)
                              }
                              download
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-primary"
                            >
                              📄{" "}
                              {typeof headerMedia === "string" ? "View Document" : headerMedia.name}
                            </a>
                          )}

                          {headerFormat === "LOCATION" && (
                            <div className="text-muted">📍 {headerText}</div>
                          )}
                        </div>
                      )}

                      <p dangerouslySetInnerHTML={{ __html: parseHtml(message) }}></p>
                      <p className="text-muted my-2">{footerText}</p>
                    </div>
                  )}

                  {/* Typing Section */}
                  <div
                    className="whatsapp-typing-bar d-flex align-items-center"
                    style={{
                      position: "absolute",
                      bottom: "0px",
                      left: "0",
                      width: "100%",
                      backgroundColor: "#ffffff",
                      borderTop: "1px solid #ddd",
                      padding: "6px 12px", // Adjusted spacing
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {/* Emoji Icon */}
                    <span
                      className="text-muted mx-2"
                      style={{ fontSize: "18px", cursor: "pointer" }}
                    >
                      <IconResource type="smile" />
                    </span>

                    {/* Input Field */}
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        alignItems: "center",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "20px",
                        padding: "6px 10px", // Adjusted padding
                      }}
                    >
                      <input
                        type="text"
                        placeholder="Type a message"
                        style={{
                          flex: 1,
                          border: "none",
                          outline: "none",
                          fontSize: "14px",
                          backgroundColor: "transparent",
                        }}
                      />

                      {/* Attach & Camera Icons */}
                      <span
                        className="text-muted mx-2"
                        style={{ fontSize: "16px", cursor: "pointer" }}
                      >
                        <IconResource type="paper-clip" />
                      </span>
                      <span
                        className="text-muted mx-2"
                        style={{ fontSize: "16px", cursor: "pointer" }}
                      >
                        <IconResource type="camera" />
                      </span>
                    </div>

                    {/* Microphone/Send Button */}
                    <span
                      className="text-muted mx-2"
                      style={{ fontSize: "16px", cursor: "pointer" }}
                    >
                      <IconResource type="mic-phone" />
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </AnimatedPage>
    );
  },
);

export default TemplateDetailsUI;
